import request from '../services/interceptor.js'

/* COMUNICAZIONI */
export const get_elencoCom = () => {
    return request({
        url: 'comunicazioni',
        method: 'get',
        loadingBar: true
    })
};

export const set_news = (par) => {
    return request({
        url: 'comunicazioni/salva',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const get_idNews = (data) => {
    return request({
        url: 'comunicazioni/nuovo',
        method: 'post',
        data: data,
        loadingBar: true,
    })
};


export const delete_news = (par) => {
    return request({
        url: 'comunicazioni/elimina/' + par,
        method: 'get',
        loadingBar: true,
    })
};

export const upload_fileNews = (par, id) => {
    return request({
        url: 'comunicazioni/file/' + id,
        method: 'post',
        data: par,
        noLoadingBar: true
    })
};


export const delete_attachment = (par) => {
    return request({
        url: 'comunicazioni/file/elimina/' + par,
        method: 'get',
        loadingBar: false,
    })
};